import { createElement, forwardRef } from 'react'
import { mergeCss } from '../css/css.mjs';
import { splitProps } from '../helpers.mjs';
import { getStyledContainerStyle } from '../patterns/styled-container.mjs';
import { styled } from './factory.mjs';

export const StyledContainer = /* @__PURE__ */ forwardRef(function StyledContainer(props, ref) {
  const [patternProps, restProps] = splitProps(props, [])

const styleProps = getStyledContainerStyle(patternProps)
const cssProps = { css: mergeCss(styleProps, props.css) }
const mergedProps = { ref, ...restProps, ...cssProps }

return createElement(styled.div, mergedProps)
  })